export class Locale {
    id: number;
    code: string;
    closes_at: number;
    opens_at: number;
    max_table_capacity: number;
    token: string;
    calls: boolean;
    colors: {};
    languages: {};
    language_active: string;
    menu: {};
    logo: string;
    direct_link_logo: string;
    personsList: {};
    is_cola: boolean;
    reservation_list: {};
    photo: string;
    reservationList: {};
    menuToken: string;
    departments: any;
    privacy_short: string;
    privacy_full: string;
    privacy_url: string;
    logo_in_widget: number;
    widget_side_img: string;
    delivery_mode: boolean;
    phone_manager: string;
    is_ordering: boolean;
    delivetyType: any;
    delivery_terms: string;
    privacy_delivery_short: string;
    privacy_delivery_full: string;
    reservations_payments_terms: string;
    reservations_payments_terms_required: number;
    marketing_consent_short: string;
    marketing_consent_full: string;
    event_mode: number;
    future_events: any[];
}
